import NextLink, { type LinkProps as _LinkProps } from 'next/link';
import { forwardRef, memo } from 'react';

export interface LinkProps<RouteInferType>
  extends Omit<_LinkProps<RouteInferType>, 'passHref'> {}

interface LinkType {
  // eslint-disable-next-line @typescript-eslint/prefer-function-type
  <RouteInferType>(props: LinkProps<RouteInferType>): JSX.Element;
}

// @ts-expect-error generic component
export const Link: LinkType = memo(
  forwardRef((props, ref) => {
    const { href, as, ...other } = props;

    return (
      <NextLink
        ref={ref}
        href={href ?? ''}
        as={as ?? href}
        passHref
        {...other}
      />
    );
  }),
);
